import React from 'react';
import Link from 'next/link';
import { jsx as _jsx } from "react/jsx-runtime";
export var TWLogo = function TWLogo(_ref) {
  var href = _ref.href,
      size = _ref.size;
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    children: /*#__PURE__*/_jsx("a", {
      children: /*#__PURE__*/_jsx("img", {
        className: "h-".concat(size, " w-auto"),
        src: "/images/img_mark.svg",
        alt: "Subkit logo"
      })
    })
  });
};
TWLogo.defaultProps = {
  size: '10'
};